import React from 'react';
import { motion } from 'framer-motion';
// import { IoCheckmark } from 'react-icons/io';
import { IoCheckmark } from "react-icons/io5";
import '../styles/Sustainability.css';

const sectionVariant = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.2 }
  })
};

const Sustainability = () => {
  return (
    <div className="sustainability-container">
      <div className="container">

      <motion.header
        className="sustainability-hero"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <h1>Sustainability</h1>
        <p>
          GGOEX is deeply committed to fostering prosperity and well-being in the communities where we operate. Our business activities not only do no harm, but actively benefit the livelihoods of those within and around our operational footprint. We hold ourselves to the highest standards, surpassing regulatory requirements as we uplift communities and infuse sustainability into every facet of our business.
        </p>
      </motion.header>

      {/* ESG Framework - 2 Column */}
      <motion.section
        className="sustainability-section"
        custom={0}
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <h2>Environmental, Social & Governance (ESG) Framework</h2>
        <div className="sustainability-esg-grid">
          {[
            {
              title: 'Environmental Stewardship',
              items: [
                "Supporting Nigeria's net-zero carbon emissions goal by 2060",
                "Carbon capture and storage (CCS) to reduce up to 65% of CO₂ emissions from gas flaring",
                "Zero-flare gas processing designs for 98% gas utilization efficiency",
                "ISO 14001:2015-aligned environmental management systems",
                "Comprehensive waste management and recycling initiatives"
              ]
            },
            {
              title: 'Social Responsibility',
              items: [
                "Host Community Development Trusts (HCDT) for socio-economic investments",
                "Active engagement with local communities for sustainable projects",
                "Training 500 Nigerian geoscientists in advanced reservoir modeling by 2027",
                "35% local content compliance and prioritizing Nigerian suppliers",
                "First consideration for Nigerian employment and training"
              ]
            },
            {
              title: 'HSSE Excellence',
              items: [
                "Comprehensive Health, Safety, Security & Environment (HSSE) policy",
                "Goal zero health, safety, and security incidents",
                "Mandatory HSSE training for all employees",
                "Continuous improvement based on global standards"
              ]
            },
            {
              title: 'Governance Excellence',
              items: [
                "Highest standards of corporate governance and ethics",
                "Transparent reporting and stakeholder engagement",
                "Compliance with laws, regulations, and guidelines",
                "Fiduciary duty, care, skill, diligence, and loyalty"
              ]
            }
          ].map((section, i) => (
            <div className="sustainability-card" key={i}>
              <h3>{section.title}</h3>
              <ul>
                {section.items.map((item, idx) => (
                  <li key={idx}>
                    <IoCheckmark className="check-icon" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </motion.section>

      {/* Key Policy Framework - 3 Column */}
      <motion.section
        className="sustainability-section"
        custom={1}
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <h2>Key Policy Framework</h2>
        <div className="sustainability-policy-grid">
          {[
            {
              title: 'Environmental Management Policy',
              text: 'Our ESG-driven Environmental and Social Standards framework guides our Board and Management in pursuing environmental, social, and economic goals of equal importance. We adopt modern Environmental Management Systems to ensure sustained improvement and regulatory compliance.'
            },
            {
              title: 'HSSE Policy',
              text: 'Founded on international guidelines and Nigerian requirements, our HSSE policy pursues safety and sustainability objectives alongside economic goals, integrating HSSE into all strategic and project plans.'
            },
            {
              title: 'Code of Business Conduct',
              text: 'All board members, employees, vendors, and contractors adhere to our standards of conduct and ethics, maintaining confidentiality and avoiding improper use of privileged information.'
            }
          ].map((item, i) => (
            <div className="sustainability-feature" key={i}>
              <h4>{item.title}</h4>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </motion.section>

      {/* Community Impact - 2 Column */}
      <motion.section
        className="sustainability-section"
        custom={2}
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        >
        <h2>Community Impact & Development</h2>
        <div className="sustainability-community-grid">
          {[
            {
              title: 'Host Community Development Trusts',
              text: 'In compliance with the Petroleum Industry Act 2021, we establish Host Community Development Trusts to create uniform mechanisms for socio-economic investments and foster sustainable prosperity in our host communities.'
            },
            {
              title: 'Local Economic Development',
              text: 'We support indigenous economic growth through sustainable supply chain policies, prioritizing Nigerian service providers and manufacturers, and investing in technology transfer and capacity building.'
            }
          ].map((item, i) => (
            <div className="sustainability-feature" key={i}>
              <h4>{item.title}</h4>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </motion.section>

      {/* Monitoring & Conclusion */}
      <motion.section
        className="sustainability-section"
        custom={3}
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <h2>Performance Monitoring & Continuous Improvement</h2>
        <p className="sustainability-conclusion">
          GGOEX maintains comprehensive monitoring systems and transparent reporting practices aligned with international standards and Nigerian regulations. Through regular policy reviews and stakeholder engagement, we ensure sustained improvement and positive impact in line with national and global sustainability goals.
        </p>
      </motion.section>
        </div>
    </div>
  );
};

export default Sustainability;
